export class InvalidImportIdException {
    invalidImportId = true;
}
